export default function renderIcon({ width="14.828" ,height="8.414", color = '#fff' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14.828 8.414">
      <path id="Path_400" data-name="Path 400" d="M6,9l6,6,6-6" transform="translate(-4.586 -7.586)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    </svg>
  )
}
